import dynamic from 'next/dynamic';
import { InsuranceModalLoading } from 'shared/components/insurance-modal-loading';

export function preloadInsuranceCall() {
  return import('./book-insurance-call');
}

const BookInsuranceCall = dynamic(() => import('./book-insurance-call'), {
  ssr: false,
  loading: InsuranceModalLoading,
});

export default BookInsuranceCall;
